import { get } from 'lodash'
import { connect } from 'react-redux'

import {
  getTimerangeIntelligence as onGetTimerangeIntelligence,
  setTimeRangeIntelligenceReady as onSetTimeRangeIntelligenceReady,
  setTimeRangeIntelligenceFailure as onSetTimeRangeIntelligenceFailure,
  resetTimeRangeIntelligence as onResetTimeRangeIntelligence,
  clearIntelligence as onClearIntelligence
} from '../../actions/timerangeIntelligenceActions'

const mapStateToProps = (state) => ({
  timerangeIntelligenceState: state.timerangeIntelligence.dataState,
  carId: get(state, ['timerangeIntelligence', 'carId'], null),
  startDate: state.timerangeIntelligence.startDate,
  endDate: state.timerangeIntelligence.endDate
})

const mapDispatchToProps = {
  onGetTimerangeIntelligence,
  onSetTimeRangeIntelligenceReady,
  onSetTimeRangeIntelligenceFailure,
  onResetTimeRangeIntelligence,
  onClearIntelligence
}

const withTimerangeIntelligence = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withTimerangeIntelligence }